
import * as apifetch from '../fetch.js';

export async function getUser(userId) {
    const urlEndpoint = 'accounts/' + userId;

    return apifetch.kkFetch(urlEndpoint, 'GET');
}

export async function getAddress(userId) {
    const urlEndpoint = 'accounts/' + userId + '/address'; 

    return apifetch.kkFetch(urlEndpoint, 'GET');
}

export async function getPets(userId) {
    const urlEndpoint = 'accounts/' + userId + '/pets'; 

    return apifetch.kkFetch(urlEndpoint, 'GET');
}

export async function saveUser(type, userId, data) {
    const urlEndpoint = 'accounts/' + userId + '/profile';

    const postData = data;

    return apifetch.kkFetch(urlEndpoint, 'PUT', postData);
}

export async function saveAddress(type, userId, data) {
    const urlEndpoint = 'accounts/' + userId + '/address'; 

    const postData = data;

    return apifetch.kkFetch(urlEndpoint, 'PUT', postData);
}

export async function savePet(type, userId, data) {
    const urlEndpoint = 'accounts/' + userId + '/pet';

    const postData = data;
    console.log('SbC pet', postData)

    return apifetch.kkFetch(urlEndpoint, 'POST', postData);
}

export async function deletePet(petId) {
    const urlEndpoint = 'pets/' + petId + '/delete';

    const postData = {};

    return apifetch.kkFetch(urlEndpoint, 'DELETE', postData);
}
